import React from "react";

const MapIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_452_9148)">
        <path
          d="M23.9851 23.1562L21.6414 11.8594C21.609 11.7006 21.5228 11.558 21.3973 11.4555C21.2718 11.353 21.1148 11.2969 20.9528 11.2969H20.2028C19.5639 12.8241 18.572 14.6086 17.2155 16.6758C15.437 19.3861 13.6576 21.6155 13.5826 21.7087C13.385 21.9555 13.1345 22.1546 12.8495 22.2914C12.5646 22.4282 12.2525 22.4993 11.9364 22.4993C11.6203 22.4993 11.3082 22.4282 11.0233 22.2914C10.7383 22.1546 10.4878 21.9555 10.2901 21.7087C10.2147 21.615 8.4353 19.3847 6.65686 16.6744C5.30217 14.6086 4.31217 12.8241 3.67139 11.2969H3.04655C2.88454 11.2969 2.72752 11.353 2.60205 11.4555C2.47658 11.558 2.39036 11.7006 2.35796 11.8594L0.014206 23.1562C-0.00664127 23.2584 -0.00452031 23.3639 0.0204154 23.4651C0.0453511 23.5663 0.0924776 23.6607 0.158384 23.7414C0.22429 23.8222 0.307327 23.8873 0.401484 23.932C0.495642 23.9767 0.598563 24 0.7028 24H23.2966C23.4008 24 23.5037 23.9767 23.5979 23.932C23.692 23.8873 23.7751 23.8222 23.841 23.7414C23.9069 23.6607 23.954 23.5663 23.9789 23.4651C24.0039 23.3639 24.006 23.2584 23.9851 23.1562Z"
          fill="white"
        />
        <path
          d="M11.9375 10.3125C13.3614 10.3125 14.5156 9.15823 14.5156 7.73438C14.5156 6.31052 13.3614 5.15625 11.9375 5.15625C10.5136 5.15625 9.35938 6.31052 9.35938 7.73438C9.35938 9.15823 10.5136 10.3125 11.9375 10.3125Z"
          fill="white"
        />
        <path
          d="M11.3891 20.8303C11.4549 20.9125 11.5385 20.9789 11.6334 21.0245C11.7284 21.0701 11.8324 21.0937 11.9377 21.0937C12.0431 21.0937 12.1471 21.0701 12.242 21.0245C12.337 20.9789 12.4205 20.9125 12.4864 20.8303C12.5042 20.8083 14.2855 18.5803 16.0409 15.9047C18.4503 12.233 19.6719 9.48281 19.6719 7.73438C19.6719 3.46875 16.2031 0 11.9375 0C7.67188 0 4.20312 3.46875 4.20312 7.73438C4.20312 9.48422 5.42469 12.2344 7.83406 15.9047C9.58906 18.5803 11.3703 20.8083 11.3891 20.8303ZM11.9366 3.75C12.7246 3.75 13.4949 3.98368 14.1502 4.42149C14.8054 4.8593 15.3161 5.48157 15.6176 6.20962C15.9192 6.93767 15.9981 7.73879 15.8444 8.51169C15.6906 9.28458 15.3112 9.99453 14.7539 10.5518C14.1967 11.109 13.4868 11.4885 12.7139 11.6422C11.941 11.7959 11.1399 11.717 10.4118 11.4155C9.68376 11.1139 9.06148 10.6032 8.62368 9.94798C8.18587 9.29275 7.95219 8.52241 7.95219 7.73438C7.95343 6.67803 8.37361 5.66531 9.12055 4.91837C9.8675 4.17142 10.8802 3.75124 11.9366 3.75Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_452_9148">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default MapIcon;
